import React from 'react'

const DashboardAnimate = ({ children, style = {} }) => {
  return (
    <div className="dashboard-animate anim-items anim-hide" style={{ width: "100%", ...style }}>{children}</div>
  )
}

export default DashboardAnimate